import Clickable from '@breeze-platform-ui/clickable';
import { Int24ArrowRight } from '@breeze-platform-ui/iconsPack';
import Loader from '@breeze-platform-ui/loader';
import cn from 'classnames';

export const SubmitButton = ({
  disabled,
  isLoading,
}: {
  disabled?: boolean;
  isLoading?: boolean;
}) => {
  return (
    <Clickable
      type="submit"
      dataQaType="submit-offer-phone-button"
      className={cn(
        'flex h-14 w-14 cursor-pointer items-center justify-center rounded-[16px] border-none p-4',
        {
          'bg-skyro-primary hover:bg-skyro-primary-hover text-white': !disabled,
        },
        { 'bg-base-02 text-base-06': disabled }
      )}
      disabled={disabled || isLoading}
    >
      {isLoading ? <Loader size="m" color="white" /> : <Int24ArrowRight />}
    </Clickable>
  );
};
